import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ExportService } from '../../services/export.service';
import { Observable, Subject, take } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { PredictorModelState } from '../../../state/predictor-model/predictor-model.state';
import { SimulationService } from '../../services/simulation.service';
import { APP_CONFIG, AppConfig } from 'src/app/appconfig/appconfig';
import { SimulationState } from '../../enums/simulation-state';
import { PredictorModelActions } from '../../../state/predictor-model/predictor-model.actions';
import { UserState } from 'src/app/state/user/user.state';

type MapType =
  | 'geotiff'
  | 'layer'
  | 'landslideSummary'
  | 'landslidesToPoints';

@Component({
  selector: 'app-export-section',
  templateUrl: './export-section.component.html',
  styleUrls: ['./export-section.component.scss'],
})
export class ExportSectionComponent implements OnInit, OnDestroy {
  @Input() resultsSimulationId: string = '';
  @Input() results: boolean = false;

  @Select(PredictorModelState.isExportingResults)
    isExportingResults$!: Observable<boolean>;

  @Select(UserState.debuggerAccess) debuggerAccess$!: Observable<boolean>;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private exportService: ExportService,
    private simulationService: SimulationService,
    private store: Store,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {}

  simulationId!: string;
  selectedZone!: number;
  form = new FormGroup({});
  model: { mapType: MapType } = { mapType: 'geotiff' };
  fields: FormlyFieldConfig[] = [
    {
      key: 'mapType',
      type: 'radioButton',
      className: 'basin-mt-4',
      props: {
        label: 'Map Type',
        selectedValue: 'geotiff',
        options: [],
      },
    },
  ];

  ngOnInit() {
    this.loadOptions();
    this.store.dispatch(new PredictorModelActions.SetExporting(false));
  }

  selectZoneForLandslidesToPoints() {
    this.exportService.exportLandslidesToPoints(this.simulationId);
  }

  setSelectedZone() {
    this.exportService.exportTIFF(this.simulationId);
  }

  export(mapType: MapType) {
    this.store.dispatch(new PredictorModelActions.SetExporting(true));
    this.simulationId = this.store.selectSnapshot(PredictorModelState.selectedSimulationId)!;

    if (this.results) {
      this.exportService.exportSimulationResult(
        this.resultsSimulationId,
        mapType
      );
      return;
    }

    switch (mapType) {
      case 'geotiff':
        this.setSelectedZone();
        break;
      case 'landslideSummary':
        this.exportService.exportLandslideSummary(this.simulationId);
        break;
      case 'landslidesToPoints':
        this.selectZoneForLandslidesToPoints();
        break;
    }
  }

  exportDisabled() {
    return !this.results && this.simulationService.simulationState !== SimulationState.Completed;
  }

  loadOptions() {
    if (this.fields[0]?.props?.options != null) {
      const fieldOptions: { label: string; value: string }[] = [
        {
          label: 'GeoTIFF',
          value: 'geotiff',
        },
        // {
        //   label: 'Layer',
        //   value: 'layer',
        // },
        {
          label: 'Landslide Summary Table',
          value: 'landslideSummary',
        },
        {
          label: 'Landslides To Points',
          value: 'landslidesToPoints',
        },
      ];

      this.fields[0].props.options = fieldOptions;
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
